import React from "react";
import ReactDOM from "react-dom";
import LocaleTextarea from "./LocaleTextarea";

export default class ReferenceableNodeGroup extends React.Component {
    constructor(props) {
        super(props);
        this.dataCache = {
            referenceablePrompts: this.props.referenceablePrompts
        }
        this.state = {
            referenceablePrompts: this.props.referenceablePrompts
        }
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.referenceablePrompts !== this.state.referenceablePrompts) {
            this.setState({referenceablePrompts: nextProps.referenceablePrompts});
        }
    }

    validateInput({ currentTarget }) {
        return currentTarget.value !== '';
    }

    getDomSelf() {
        return $(ReactDOM.findDOMNode(this));
    }

    setConfig(key, newValue) {
        if (key === "prompt") {
            const { lang, value, idx } = newValue;
            const prompt = this.props.referenceablePrompts[idx];

            //update the components object
            const componentsNode = window.apm.serialized.components.objects.filter(obj => obj.name === prompt.name)[0];
            componentsNode.props.config.text[lang] = value;
        }

        window.apm.setSerializedChanged();
        window.apm.postEventToCurrentView({ target: "request-refresh" });
    }

    getConfig(key) {
        return this.dataCache[key];
    }

    render() {

        var engSel = window.apm.knowledgeBase.getItemFromValue("en-US", window.apm.serialized.languages, "language");

        return (
            <div className="panel-group" role="tablist">
                <div className="panel panel-default">
                    <div className="panel-heading" role="tab" style={{ padding: "0", paddingLeft: "15px" }}>
                        <div className={"row"}>
                            <div className={"col-md-10"} style={{ padding: "10px" }}>
                                <div className="panel-title"
                                     onClick={() => {
                                         this.getDomSelf().find(".collapse[data-tracker='referenceablePrompts']").collapse('toggle');
                                     }}
                                >
                                    <i className={"fe icon-link"} />
                                    &nbsp;&nbsp;Referenceable Prompts
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="panel-collapse collapse in" role="tabpanel" data-tracker="referenceablePrompts">
                        <div className="panel-body">
                            <div className="row">
                                <table className={"table table-condensed"}>
                                    <thead>
                                    <tr style={{ color: "var(--color-text-lightest)", fontSize: "14px" }}>
                                        <td style={{ width: "20%" }}>{window.l.settings.prompt_node_name}</td>
                                        <td style={{ width: "40%" }}>English - {engSel.voice}</td>
                                        {this.props.language !== "en-US" && <td style={{ width: "40%" }}>{this.props.language} - {this.props.voice}</td>}
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.referenceablePrompts.map((rp, idx) => {
                                        return  <tr key={rp.id}>
                                                    <td><label>{rp.name}</label></td>
                                                    <td>
                                                        <LocaleTextarea
                                                            rowsVal={4}
                                                            defaultValue={rp.props.config.text["en-US"]}
                                                            valKey={"prompt"}
                                                            idx={idx}
                                                            context={this}
                                                            type={"prompt"}
                                                            language={this.props.language}
                                                            isEnUS={true}
                                                        />
                                                    </td>
                                                    <td>
                                                        {this.props.language !== "en-US" &&
                                                        <LocaleTextarea
                                                            rowsVal={4}
                                                            defaultValue={rp.props.config.text[this.props.language] || ""}
                                                            valKey={"prompt"}
                                                            idx={idx}
                                                            context={this}
                                                            type={"prompt"}
                                                            language={this.props.language}
                                                            isEnUS={false}
                                                        />
                                                        }
                                                    </td>
                                                    </tr>})
                                    }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
